module.exports = __webpack_public_path__ + "img/bory-logo-penta.630540f7.png";